import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialogRescreenStep2.vue?vue&type=template&id=701356a1&scoped=true"
import script from "./VerifyEmployeeRegistrationDialogRescreenStep2.vue?vue&type=script&lang=js"
export * from "./VerifyEmployeeRegistrationDialogRescreenStep2.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmployeeRegistrationDialogRescreenStep2.vue?vue&type=style&index=0&id=701356a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701356a1",
  null
  
)

export default component.exports